import { FormikProps } from 'formik'
import React, { CSSProperties } from 'react'
import styled from 'styled-components'
import { FormItem } from 'sutra/components/Form'
import { Input } from 'sutra/components/Input/Input'

type Props = {
  formik: FormikProps<Record<string, unknown>>
  field: string
  label: string
  disabled?: boolean
  style?: CSSProperties
}

export const FormikFormItem: React.FC<Props> = ({
  formik,
  label,
  field,
  disabled,
  style,
}) => {
  return (
    <FormItem label={label} style={style || {}}>
      <StyledInput
        name={field}
        onChange={formik.handleChange}
        value={formik.values[field] as string | undefined}
        disabled={disabled}
      />
      <Error>{formik.errors?.[field]}</Error>
    </FormItem>
  )
}

const Error = styled.div`
  text-align: center;
  color: #ff4d4f;
  position: absolute;
  top: 100%;
  font-size: var(--font-size-sm);
`

const StyledInput = styled(Input)`
  background: white;
  border: 2px solid var(--card-border-grey);
  border-radius: 6px;
`
